import { render, staticRenderFns } from "./CustomerNote.vue?vue&type=template&id=aa4b3cd8&scoped=true&"
import script from "./CustomerNote.vue?vue&type=script&lang=js&"
export * from "./CustomerNote.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNote.vue?vue&type=style&index=0&id=aa4b3cd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4b3cd8",
  null
  
)

export default component.exports